import { jsx as i } from "react/jsx-runtime";
import m from "./Carousel.js";
import p from "./CarouselItem.js";
import { TransformationImageCard as c } from "../TransformationImageCard/index.js";
function C({
  transformations: e = [],
  textCardBackgroundColor: l,
  hasControls: o = !0
}) {
  return /* @__PURE__ */ i(
    m,
    {
      controls: o,
      controlsBackgroundColor: l,
      children: e == null ? void 0 : e.map((r) => /* @__PURE__ */ i(p, { children: /* @__PURE__ */ i(
        c,
        {
          title: r.title,
          description: r.description,
          imageUrl: r.imageUrl,
          textCardBackgroundColor: l
        }
      ) }))
    }
  );
}
export {
  C as TransformationImageCardCarousel
};
